module.exports = __webpack_public_path__ + "static/media/mickael-cv-fr.b4ec636b.pdf";